import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { SubmissionSteps } from '../helpers/submissionConfig';
import Check from '@images/svg/ui/check.svg';
import { SubmissionContext } from '../utils/SubmissionContextProvider';

const SubmissionStep = ({
  canGoNext,
  children,
  direction,
  displayOffset,
  handleGoNext,
  index,
  buttonLabel,
  onSendSubmission
}) => {
  // eslint-disable-next-line no-nested-ternary
  const offset = displayOffset > 2 ? 2 : displayOffset < -1 ? -1 : displayOffset;
  const context = useContext(SubmissionContext);

  const handleSubmit = event => {
    event.preventDefault();
    event.stopPropagation();
    document.activeElement.blur(); // Force hiding mobile keyboard
    if (onSendSubmission && canGoNext) {
      onSendSubmission();
    } else if (handleGoNext && canGoNext) {
      handleGoNext();
    }
  };

  return (
    <form
      action='#'
      onSubmit={handleSubmit}
      className='c-submission-step'
      data-offset={offset}
      data-direction={direction}
    >
      {!SubmissionSteps[index]?.headline ? null : (
        <h2 className='c-submission-step__headline'>{SubmissionSteps[index]?.headline}</h2>
      )}
      <div className='c-submission-step__invalid-message'>
        {!SubmissionSteps[index].isValid(context) &&
          typeof SubmissionSteps[index].invalidMessageCanShow === 'function' &&
          SubmissionSteps[index].invalidMessageCanShow(context) &&
          SubmissionSteps[index].invalidMessage}
      </div>
      <div className='c-submission-step__content'>{children}</div>
      <button
        className='c-submission-step__confirm'
        disabled={!canGoNext}
        title={buttonLabel || 'Okay'}
        onClick={handleSubmit}
      >
        <span>{buttonLabel || 'Okay'}</span>
        <Check />
      </button>
    </form>
  );
};

SubmissionStep.propTypes = {
  buttonLabel: PropTypes.string,
  canGoNext: PropTypes.bool,
  children: PropTypes.any,
  direction: PropTypes.string,
  displayOffset: PropTypes.number.isRequired,
  handleGoNext: PropTypes.func,
  index: PropTypes.number,
  onSendSubmission: PropTypes.func
};

export default SubmissionStep;
